// extracted by mini-css-extract-plugin
export default {"cart":"CartModal_cart__xZqmI"};